/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Status_Subline_MaxedInputs */



/**
* | output |
* | --- |
* | "Further requests are blocked until your pool resets." |
*
* @param {Usage_Status_Subline_MaxedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_subline_maxed = /** @type {((inputs?: Usage_Status_Subline_MaxedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Subline_MaxedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Anfragen werden blockiert, bis Ihr Pool zurückgesetzt wird.")
	return /** @type {LocalizedString} */ ("Further requests are blocked until your pool resets.")
});